module.exports = __webpack_public_path__ + "static/media/KEC-Logo.26950e08.png";